module.exports = __webpack_public_path__ + "img/L_4C.5d000bc1.png";